var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 26C16.7478 26 18.1044 25.4381 19.1046 24.4379C20.1048 23.4377 20.6667 22.0812 20.6667 20.6667V15.3333H15.3333M31.3333 26C32.7478 26 34.1044 25.4381 35.1046 24.4379C36.1048 23.4377 36.6667 22.0812 36.6667 20.6667V15.3333H31.3333M50 34C50 35.4145 49.4381 36.771 48.4379 37.7712C47.4377 38.7714 46.0812 39.3333 44.6667 39.3333H12.6667L2 50V7.33333C2 5.91885 2.5619 4.56229 3.5621 3.5621C4.56229 2.5619 5.91885 2 7.33333 2H44.6667C46.0812 2 47.4377 2.5619 48.4379 3.5621C49.4381 4.56229 50 5.91885 50 7.33333V34Z",
    stroke: "#6D33FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 26C16.7478 26 18.1044 25.4381 19.1046 24.4379C20.1048 23.4377 20.6667 22.0812 20.6667 20.6667V15.3333H15.3333M31.3333 26C32.7478 26 34.1044 25.4381 35.1046 24.4379C36.1048 23.4377 36.6667 22.0812 36.6667 20.6667V15.3333H31.3333M50 34C50 35.4145 49.4381 36.771 48.4379 37.7712C47.4377 38.7714 46.0812 39.3333 44.6667 39.3333H12.6667L2 50V7.33333C2 5.91885 2.5619 4.56229 3.5621 3.5621C4.56229 2.5619 5.91885 2 7.33333 2H44.6667C46.0812 2 47.4377 2.5619 48.4379 3.5621C49.4381 4.56229 50 5.91885 50 7.33333V34Z",
    stroke: "url(#paint0_linear_49096_4641)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49096_4641",
    x1: -1.18156,
    y1: 11.7696,
    x2: 51.9574,
    y2: 40.1482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.cd5c3fc6545a09ee73f0fdda74ffc0f5.svg";
export { ForwardRef as ReactComponent };